export const FETCH_PAYMENT_ORDER_LIST_PENDING =
  'FETCH_PAYMENT_ORDER_LIST_PENDING';
export const FETCH_PAYMENT_ORDER_LIST_REJECTED =
  'FETCH_PAYMENT_ORDER_LIST_REJECTED';
export const FETCH_PAYMENT_ORDER_LIST_FULFILLED =
  'FETCH_PAYMENT_ORDER_LIST_FULFILLED';
export const START_PAYMENT_ORDER_LIST_AUTO_RELOAD =
  'START_PAYMENT_ORDER_LIST_AUTO_RELOAD';
export const STOP_PAYMENT_ORDER_LIST_AUTO_RELOAD =
  'STOP_PAYMENT_ORDER_LIST_AUTO_RELOAD';
export const SET_ACTIVE_STATUS_FOR_PAYMENT_ORDER_LIST =
  'SET_ACTIVE_STATUS_FOR_PAYMENT_ORDER_LIST';
export const CLEAR_PAYMENT_ORDER_LIST = 'CLEAR_PAYMENT_ORDER_LIST';
export const FETCH_FILTER_ATTRS_FULFILLED = 'FETCH_FILTER_ATTRS_FULFILLED';
export const SELECTED_FILTER_ATTRS = 'SELECTED_FILTER_ATTRS';



// WEBPACK FOOTER //
// ./src/constants/paymentOrderList.js